import { render, staticRenderFns } from "./PageNominator.vue?vue&type=template&id=67d00cfa&"
import script from "./PageNominator.vue?vue&type=script&lang=js&"
export * from "./PageNominator.vue?vue&type=script&lang=js&"
import style0 from "./PageNominator.vue?vue&type=style&index=0&id=67d00cfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports